import { render, staticRenderFns } from "./RenderCheckLabelRequired.vue?vue&type=template&id=06f4165f&functional=true&"
import script from "./RenderCheckLabelRequired.vue?vue&type=script&lang=js&"
export * from "./RenderCheckLabelRequired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports